/** Eén profiel als personaliteits-/designlijn-paar (bv. 4/6). */
export interface HdProfileDefinition {
  readonly personality: number;
  readonly design: number;
}

/**
 * De 12 profielen in de canonieke volgorde van het Basis Rapport en de
 * profielen-cheat-sheets: eerst de persoonlijke (rechte hoek), dan het vaste
 * profiel (juxtapositie, 4/1), dan de interpersoonlijke (linkse hoek).
 */
export const HD_PROFILE_DEFINITIONS: readonly HdProfileDefinition[] = [
  { personality: 1, design: 3 },
  { personality: 1, design: 4 },
  { personality: 2, design: 4 },
  { personality: 2, design: 5 },
  { personality: 3, design: 5 },
  { personality: 3, design: 6 },
  { personality: 4, design: 6 },
  { personality: 4, design: 1 },
  { personality: 5, design: 1 },
  { personality: 5, design: 2 },
  { personality: 6, design: 2 },
  { personality: 6, design: 3 },
];

/** De zes profiellijnen; ook de sleutels van de rollen-secties (`roles-line-{n}`). */
export const HD_PROFILE_ROLE_LINES: readonly number[] = [1, 2, 3, 4, 5, 6];

/** Bestandssleutel van een profiel-document: `"4-6"`. */
export function hdProfileKey(profile: HdProfileDefinition): string {
  return `${profile.personality}-${profile.design}`;
}

/** Weergavelabel van een profiel: `"4/6"`. */
export function hdProfileLabel(profile: HdProfileDefinition): string {
  return `${profile.personality}/${profile.design}`;
}
